module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/compilation-a3b0c33ceea54df7a672c8b41fae1c1e.svg";